import { useEffect, useRef } from "react";

const time = (value) => new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

/**
 * Campanita de avisos del chat.
 *
 * Marca cuándo ha escrito alguien en una conversación que no se está mirando.
 * Al pulsar un aviso se salta a esa conversación, que es lo único que se puede
 * querer hacer con él.
 */
export default function ChatBell({ notifications, onOpenNotice }) {
    const { items, unread, open, ringing, toggle, setOpen, clear } = notifications;
    const boxRef = useRef(null);

    // Un panel flotante que no se cierra al pulsar fuera se queda tapando el
    // chat justo cuando el usuario quiere volver a él.
    useEffect(() => {
        if (!open) return undefined;

        const close = (event) => {
            if (!boxRef.current?.contains(event.target)) setOpen(false);
        };

        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, [open, setOpen]);

    return (
        <div className="chat-bell" ref={boxRef}>
            <button
                type="button"
                className={`chat-bell-btn ${ringing ? 'is-ringing' : ''}`}
                onClick={toggle}
                aria-label={unread ? `${unread} mensajes nuevos` : 'Avisos del chat'}
            >
                <i className="fa-solid fa-bell"></i>
                {unread > 0 && <span className="chat-bell-badge">{unread > 9 ? '9+' : unread}</span>}
            </button>

            {open && (
                <div className="chat-bell-panel">
                    <div className="chat-bell-panel-head">
                        <span>Avisos</span>
                        {items.length > 0 && (
                            <button type="button" className="chat-bell-clear" onClick={clear}>
                                Limpiar
                            </button>
                        )}
                    </div>

                    {items.length === 0 && <p className="chat-bell-empty">Nada nuevo por ahora.</p>}

                    {items.map((item) => (
                        <button
                            type="button"
                            key={item.id}
                            className={`chat-bell-item ${item.seen ? '' : 'is-new'}`}
                            onClick={() => {
                                onOpenNotice(item);
                                setOpen(false);
                            }}
                        >
                            <span className="chat-bell-item-head">
                                <i className={`fa-solid ${item.tip ? 'fa-coins' : item.surface === 'private' ? 'fa-lock' : 'fa-comments'}`}></i>
                                <strong>{item.title}</strong>
                                <span className="chat-bell-item-time">{time(item.at)}</span>
                            </span>
                            <span className="chat-bell-item-body">{item.body}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
